import { render, staticRenderFns } from "./updatatrader2.vue?vue&type=template&id=786b13a8&scoped=true&"
import script from "./updatatrader2.vue?vue&type=script&lang=js&"
export * from "./updatatrader2.vue?vue&type=script&lang=js&"
import style0 from "./updatatrader2.vue?vue&type=style&index=0&id=786b13a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b13a8",
  null
  
)

export default component.exports